import React, { useEffect, useState } from "react";
import {
    Box, Stack, Paper, Typography, IconButton,
    Tooltip
} from "@mui/material";
import { DataGrid } from '@mui/x-data-grid';
import { withTranslation } from "react-i18next";
import { AmountFormat, CheckAccessFunc } from "../../../Components/CommonFunctions/CommonFunctions";
import { CommonPatientDetails } from '../../../Components/Common Components/CommonComponents';
import RestAPIService from "../../../Utility/Services/RestAPIService";
import { Serviceurls } from "../../../Utility/API/Serviceurls";
import ToastMsg from '../../../Components/ToastMsg/ToastMsg';
import Loader from '../../../Components/Loader';
import { ImagePaths } from '../../../Utility/ImagePaths';
import { CurrencySymbol } from "../../../Utility/Constants";
import { ArrowBackIos } from "@material-ui/icons";

const PatientIndividualPayement = ({ t, history }) => {
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [isLoader, setIsLoader] = useState(false);
    const [isErrorMsg, setIsErrorMsg] = useState(false);
    const [isErrorMsgText, setIsErrorMsgText] = useState('');
    const [successMsg, setSuccessMsg] = useState(false);
    const [successMsgText, setSuccessMsgText] = useState('');
    const [Providerdetails, setProviderDetails] = useState({
        insuranceName: "",
        noOfBills: 0,
        totalAmount: 0,
        totalOutstanding: 0,
        totalPaidAmount: 0,
    })
    const [PatientList, setPatientList] = useState([])
    const [companyId, setcompanyId] = useState(null)
    const mockData = [
        {
          sno: 1,
          patient_name: 'John Doe',
          no_of_bills: 45,
          admission_id: 'ADM001/IP/2425',
          admission_date: '2025-03-01',
          total_bill_amount: 12000,
          total_paid_amount: 8000,
          total_balance_amount: 4000,
          payment_status: 0
        },
        {
          sno: 2,
          patient_name: 'Jane Smith',
          no_of_bills: 5,
          admission_id: 'ADM002/IP/2425',
          admission_date: '2025-03-05',
          total_bill_amount: 15000,
          total_paid_amount: 15000,
          total_balance_amount: 0,
          payment_status: 1
        },
        {
          sno: 3,
          patient_name: 'Michael Johnson',
          admission_id: 'ADM003/IP/2425',
          no_of_bills: 2,
          admission_date: '2025-03-10',
          total_bill_amount: 20000,
          total_paid_amount: 5000,
          total_balance_amount: 15000,
          payment_status: 0
        },
        {
          sno: 4,
          patient_name: 'Emily Davis',
          admission_id: 'ADM004/IP/2425',
          no_of_bills: 24,
          admission_date: '2025-03-12',
          total_bill_amount: 10000,
          total_paid_amount: 10000,
          total_balance_amount: 0,
          payment_status: 1
        },
        {
          sno: 5,
          patient_name: 'William Brown',
          admission_id: 'ADM005/IP/2425',
          no_of_bills: 53,
          admission_date: '2025-03-15',
          total_bill_amount: 8000,
          total_paid_amount: 3000,
          total_balance_amount: 5000,
          payment_status: 0
        }
      ];
      
    useEffect(() => {
        const companyId = history?.location?.state?.companyId;
        if (companyId) {
            setcompanyId(companyId);
        }
    }, [history]);

    useEffect(() => {
        if (companyId) {
            // getPatientCreditList();
        }
    }, [companyId]);

    const getPatientCreditList = async () => {
        setIsLoader(true);
        try {
            const response = await RestAPIService.getAll(`${Serviceurls.PURCHASE_VENDOR_MONTHLY}?Patient_id=${companyId}`);
            if (response.data.status === "success") {
                const list = response.data.data?.map((item, i) => ({ ...item, sno: i + 1 })) || [];
                setProviderDetails(prev => ({
                    ...prev,
                    insuranceName: response.data?.insurance_name || "",
                    totalAmount: response.data?.total_bill_amount || 0,
                    totalOutstanding: response.data?.total_balance_amount || 0,
                    totalPaidAmount: response.data?.total_paid_amount || 0,
                }));
                setPatientList(list);
            }
        } catch (error) {
            if (error.response?.data?.status === "fail") {
                setIsErrorMsg(true);
                setIsErrorMsgText(error.response?.data?.message);
            }
        } finally {
            setIsLoader(false);
        }
    };

    const handlePaybackClick = (row) => {

    };

    const columns = [
        { field: 'sno', headerName: 'S.No', flex: 0.04 },
        {
            field: "patient_name", headerName: 'Patient Details', flex: 0.142,
            renderCell: ({ row }) => (<Box component={'div'}><CommonPatientDetails data={row} />
            </Box>)
        },
        {
            field: 'admission_id', headerName: 'Admission Details', flex: 0.142,
            renderCell: ({ row }) => (<Box component={'div'}>
                <Typography component={'div'}>{row?.admission_id}</Typography>
                <Typography component={'div'} style={{color:"grey",fontSize:".8dvw"}}>{row?.admission_date}</Typography>
            </Box>)
        },
        {
            field: 'no_bills', headerName: `No Of Bills`, flex: 0.07,
            renderCell: ({ row }) => row?.no_of_bills
        },
        {
            field: 'total_bill_amount', headerName: `Bill Amount (${CurrencySymbol})`, flex: 0.14,
            renderCell: ({ row }) => AmountFormat(row?.total_bill_amount || 0).replace(CurrencySymbol, "")
        },
        {
            field: 'total_paid_amount', headerName: `Paid Amount (${CurrencySymbol})`, flex: 0.14,
            renderCell: ({ row }) => AmountFormat(row?.total_paid_amount || 0).replace(CurrencySymbol, "")
        },
        {
            field: 'total_balance_amount', headerName: `Outstanding (${CurrencySymbol})`, flex: 0.14,
            renderCell: ({ row }) => (
                <Typography sx={{ color: +row.total_balance_amount === 0 ? "#1E972A" : "#B82121" }}>
                    {AmountFormat(row?.total_balance_amount || 0).replace(CurrencySymbol, "")}
                </Typography>
            )
        },
        {
            field: 'payment_status', headerName: 'Status', flex: 0.125,
            renderCell: ({ row }) => (
                <Typography>{row.payment_status === 1 ? "Completed" : "Pending"}</Typography>
            )
        },
        {
            field: 'actions', headerName: 'Action', flex: 0.125,
            renderCell: ({ row }) => (
                 <Tooltip title={t("Payback")} placement="top" arrow>
                    <IconButton disabled={!CheckAccessFunc("Front Office", "Settlement", "Corporate Provider","Credit Payment", "SubTab")?.editAccess && (row.payment_status === 1 || row.payment_status === null)} size="small" sx={{ borderRadius: "0.3vw" }} onClick={() => handlePaybackClick(row)}>
                        <img className="emedhub_vendor_img2" src={ImagePaths.Wallet.default} alt="Wallet" />
                    </IconButton>
                </Tooltip>
            )
        }
    ];

    return (
        <Box className="emedhub__purchase_page">
            <Paper sx={{marginBottom:'1vw'}}>
                <IconButton onClick={() => history.push({ pathname: "/CreditSettlement" })} data-testid="back-button">
                    <ArrowBackIos /><Typography>Back to provider</Typography>
                </IconButton>
            </Paper>
            <Paper>
            <Typography style={{borderBottom:"1px solid #dddddd", fontSize:"0.8dvw", color:"#adadad",padding:"0.7dvw"}}>PROVIDER INFROATION</Typography>
            </Paper>
            <Paper className="eMed_PharmaVendor_paper" elevation={2}>
                <Stack direction="row" sx={{ padding: "1vw" }} spacing={20}>
                    <Stack spacing={2}>
                        <Typography>{t("Corporate Provider")}</Typography>
                        <Typography style={{fontSize:"1.5rem", fontWeight:"bold"}}>{Providerdetails?.insuranceName || '-'}</Typography>
                    </Stack>
                    <Stack spacing={2}>
                        <Typography>{t("No Of Bills")}</Typography>
                        <Typography>{Providerdetails?.noOfBills}</Typography>
                    </Stack>
                    <Stack spacing={2}>
                        <Typography>{t("Total Amount")}</Typography>
                        <Typography>{AmountFormat(Providerdetails?.totalAmount || 0)}</Typography>
                    </Stack>
                    <Stack spacing={2}>
                        <Typography>{t("OutStanding Amount")}</Typography>
                        <Typography>{AmountFormat(Providerdetails?.totalOutstanding || 0)}</Typography>
                    </Stack>
                    <Stack spacing={2}>
                        <Typography>{t("Paid Amount")}</Typography>
                        <Typography>{AmountFormat(Providerdetails?.totalPaidAmount || 0)}</Typography>
                    </Stack>
                </Stack>
            </Paper>
            <Box sx={{ m: 2, height: '60vh', width: '100%' }}>
                <DataGrid
                    rows={ mockData || []}
                    columns={columns}
                    pageSize={pageSize}
                    page={page}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    onPageChange={(newPage) => setPage(newPage)}
                    rowsPerPageOptions={[10, 20, 30]}
                    getRowId={(row) => row.sno}
                    hideFooterSelectedRowCount
                    pagination
                />
            </Box>
            <Loader loaderOpen={isLoader} />
            {isErrorMsg && <ToastMsg severity='error' msg={isErrorMsgText} msgPop={() => setIsErrorMsg(false)} />}
            {successMsg && <ToastMsg severity='success' msg={successMsgText} msgPop={() => setSuccessMsg(false)} />}
        </Box>
    );
};

export default withTranslation()(PatientIndividualPayement);
